// src/components/dashboard/ProgramPerformanceChart.js
import React from 'react';
import { Bar } from 'react-chartjs-2'; // Import the Bar chart component
import {
    Chart as ChartJS, // Renamed Chart to ChartJS to avoid conflict
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js'; // Import necessary Chart.js elements

// Register the necessary components for Chart.js
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const ProgramPerformanceChart = () => {
    // Mock data for loyalty program performance (Points Issued vs. Points Redeemed)
    const performanceData = [
        { month: 'Jan', issued: 15000, redeemed: 8000 },
        { month: 'Feb', issued: 18000, redeemed: 9500 },
        { month: 'Mar', issued: 17000, redeemed: 10000 },
        { month: 'Apr', issued: 20000, redeemed: 12000 },
        { month: 'May', issued: 22000, redeemed: 13500 },
        { month: 'Jun', issued: 25000, redeemed: 15000 },
    ];

    // Prepare data in Chart.js format
    const data = {
        labels: performanceData.map(data => data.month), // e.g., ['Jan', 'Feb', 'Mar']
        datasets: [
            {
                label: 'Points Issued',
                data: performanceData.map(data => data.issued),
                backgroundColor: 'rgba(99, 102, 241, 0.8)', // Tailwind indigo-500
                borderColor: 'rgba(99, 102, 241, 1)',
                borderWidth: 1,
            },
            {
                label: 'Points Redeemed',
                data: performanceData.map(data => data.redeemed),
                backgroundColor: 'rgba(16, 185, 129, 0.8)', // Tailwind green-500
                borderColor: 'rgba(16, 185, 129, 1)',
                borderWidth: 1,
            },
        ],
    };

    // Chart.js options
    const options = {
        responsive: true,
        maintainAspectRatio: false, // Allows the chart to fill its parent container
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    font: {
                        size: 14,
                        family: 'Inter, sans-serif' // Or your chosen font
                    },
                    color: '#374151', // gray-700
                }
            },
            title: {
                display: false, // Title already handled by h3 tag
                text: 'Loyalty Program Performance',
            },
            tooltip: {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                bodyFont: {
                    size: 14,
                    family: 'Inter, sans-serif'
                },
                titleFont: {
                    size: 16,
                    family: 'Inter, sans-serif',
                    weight: 'bold'
                }
            }
        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
                ticks: {
                    color: '#4b5563', // gray-600
                    font: {
                        size: 12,
                        family: 'Inter, sans-serif'
                    }
                }
            },
            y: {
                beginAtZero: true,
                grid: {
                    color: 'rgba(209, 213, 219, 0.4)', // Light gray
                },
                ticks: {
                    color: '#4b5563', // gray-600
                    font: {
                        size: 12,
                        family: 'Inter, sans-serif'
                    },
                    callback: function(value) {
                        return value.toLocaleString(); // Format numbers with commas
                    }
                }
            },
        },
    };

    return (
        <div className="bg-white rounded-lg shadow-md p-6 h-96 flex flex-col">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Loyalty Program Performance (Points Activity)</h3>
            <p className="text-sm text-gray-500 mb-4">Points Issued vs. Redeemed over the last 6 months</p>

            <div className="flex-1 relative"> {/* Make this relative for chart to fill */}
                {/* The Bar component from react-chartjs-2 */}
                <Bar data={data} options={options} />
            </div>
        </div>
    );
};

export default ProgramPerformanceChart;